<template>
  <div class="desp">
    <div class="desp-header">Confirmation:</div>
    <div class="desp-items-group">
      <div class="desp-items-group-title-icon">
        <svg-icon name="applicant" class="jump-icon"></svg-icon>
        Applicant information
      </div>
      <div class="desp-items-wrapper">
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="desp-item">
              <div class="desp-item-label">Applicant Name</div>
              <div class="desp-item-content">{{ detail.applicantName }}</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="desp-item">
              <div class="desp-item-label">Mobile</div>
              <div class="desp-item-content">{{ detail.applicantPhone }}</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="desp-item">
              <div class="desp-item-label">Email</div>
              <div class="desp-item-content">{{ detail.applicantEmail }}</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="desp-item">
              <div class="desp-item-label">Residential Address</div>
              <div class="desp-item-content">{{ detail.residentialAddress }}</div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="desp-item">
              <div class="desp-item-label">Applicant role</div>
              <template
                v-if="
                  (detail.applymentStatus === 'REVISING' ||
                    detail.applymentStatus === 'CORRECTED' ||
                    detail.applymentStatus === 'ILLEGAL' ||
                    detail.applymentStatus === 'AUDIT_FAIL' ||
                    detail.applymentStatus === 'REFUND_APPLY_DENY' ||
                    detail.applymentStatus === 'REFUND_APPLY_REJECT' ||
                    detail.applymentStatus === 'ACRA_REJECTED') &&
                  isApplymentAuth('company:coordinate')
                "
              >
                <el-select :value="applicantRole" placeholder="Please Select" class="wd320" @change="applicantPositionChange">
                  <el-option
                    v-for="item in applicantPositionOptions"
                    :key="`applicantPosition${item.value}`"
                    :label="item.title"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </template>
              <div class="desp-item-content" v-else>{{ applicantPositionFormat(detail.applicantPosition) }}</div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="desp-items-group">
      <div class="desp-items-group-title-icon">
        <svg-icon name="country" class="jump-icon"></svg-icon>
        Location of the proposed company/fund
      </div>
      <div class="desp-item">
        <div class="desp-item-self">{{ detail.country }}</div>
      </div>
    </div>
    <div class="desp-items-group">
      <div class="desp-items-group-title-icon">
        <svg-icon name="planAndServices" class="jump-icon"></svg-icon>
        Choice of service(s)
      </div>
      <div class="desp-items-wrapper">
        <div class="desp-item">
          <div class="desp-item-label">Entity type</div>
          <div class="desp-item-content">{{ entityTypeFormat(detail.businessGenre) }}</div>
        </div>
        <div class="desp-item">
          <div class="desp-item-label">Business type</div>
          <div class="desp-item-content">{{ businessTypeFormat(detail.businessType) }}</div>
        </div>
        <template v-if="detail.businessType == 'COMPREHENSIVE_CUSTOMIZED' || detail.businessType == 'FUND_ADMIN_CUSTOMIZED'">
          <div class="desp-item">
            <div class="desp-item-label">Promotion code</div>
            <div class="desp-item-content">{{ detail.promotionCode }}</div>
          </div>
        </template>
      </div>
      <div class="desp-item">
        <div class="desp-item-self">
          <!-- 公司设立、服务转移 -->
          <div class="mt10" v-if="detail.businessType == 'COMPANY_INCORPORATION' || detail.businessType == 'SERVICE_TRANSFER'">
            <!-- 套餐 -->
            <template v-if="detail.goodsListType == 1">
              <Package :goodsList="detail.goodsList" />
            </template>
            <!-- 自定义套餐 -->
            <template v-if="detail.goodsListType == 2">
              <diy-package :businessType="detail.businessType" :goodsList="detail.goodsList" />
            </template>
          </div>
          <!-- 综合性公司服务–定制化、 基金托管服务–定制化 -->
          <div class="mt10" v-if="detail.businessType == 'COMPREHENSIVE_CUSTOMIZED' || detail.businessType == 'FUND_ADMIN_CUSTOMIZED'">
            <!-- Quotation定制化服务-报价(列表) -->
            <quotation-list :quotationList="detail.quotationList" :orderInfoList="detail.orderInfoList" :orderRefundList="detail.orderRefundList" />
          </div>
        </div>
      </div>
    </div>

    <!-- 发票 -->
    <div class="desp-items-group" v-if="detail.businessType == 'COMPANY_INCORPORATION' || detail.businessType == 'SERVICE_TRANSFER'">
      <div class="desp-items-group-title">Generic Invoice</div>
      <div class="desp-item">
        <div class="flex desp-item-self">
          <div v-for="item in detail.orderInfoList" :key="`order-${item.id}`">
            <span class="mr30 to-link" @click="invoiceLink(item.customerInvoice.invoiceNumber)" v-if="item.customerInvoice.invoiceNumber">Invoice</span>
          </div>
          <div v-for="item in detail.orderRefundList" :key="`orderRefund-${item.id}`">
            <span class="mr30 to-link" @click="invoiceLink(item.customerInvoice.invoiceNumber)" v-if="item.customerInvoice.invoiceNumber">
              Credit Invoice
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- 前台详情页链接 -->
    <div class="desp-items-group" v-if="isAuth('company:coordinate')">
      <div class="desp-items-group-title">Front user website</div>
      <div class="desp-item">
        <div class="desp-item-self">
          <span class="mr40 to-link" @click="userDetailLink('details')">View details</span>
        </div>
      </div>
    </div>

    <!-- 前台收费协议页链接 -->
    <div
      class="desp-items-group"
      v-if="isAuth('company:coordinate') && (detail.businessType == 'COMPREHENSIVE_CUSTOMIZED' || detail.businessType == 'FUND_ADMIN_CUSTOMIZED')"
    >
      <div class="desp-items-group-title">Front user Fee Letter</div>
      <div class="desp-item">
        <div class="desp-item-self">
          <span class="mr40 to-link" @click="userDetailLink('feeLetter', 'en')">View Fee Letter(EN)</span>
          <span class="to-link" @click="userDetailLink('feeLetter', 'zh')">View Fee Letter(CN)</span>
        </div>
      </div>
    </div>

    <!-- 服务报价书 -->
    <div
      class="desp-items-group"
      v-if="
        isAuth('company:coordinate') &&
        (detail.businessType == 'COMPREHENSIVE_CUSTOMIZED' || detail.businessType == 'FUND_ADMIN_CUSTOMIZED') &&
        detail.feeLetterUrls &&
        detail.feeLetterUrls.length > 0
      "
    >
      <div class="desp-items-group-title">Service Quotation</div>
      <div class="pt10 desp-item">
        <div class="desp-item-self">
          <p v-for="item in detail.feeLetterUrls" :key="item.url" class="m0 lh22 pb10">
            <a :href="item.url" target="_blank" class="fs14 blue">{{ item.name }}</a>
          </p>
        </div>
      </div>
    </div>

    <!-- 续约申请单号码 -->
    <div class="desp-items-group" v-if="isAuth('company:coordinate') && detail.hasRenew">
      <div class="desp-items-group-title">Linked Transaction No. (Renewal)</div>
      <div class="desp-item">
        <div class="desp-item-self">
          <span>
            {{ detail.linkedApplymentNo }}
            {{ applymentStatusFormat(detail?.linkedApplyment?.applymentStatus, true) }}
          </span>
        </div>
      </div>
    </div>

    <!-- 增加服务申请单号码 -->
    <div class="desp-items-group" v-if="isAuth('company:coordinate') && detail.hasLaterService">
      <div class="desp-items-group-title">Linked Transaction No. (Supplemental)</div>
      <div class="desp-item">
        <div class="desp-item-self">
          <span class="mr50" v-for="item in detail.laterServiceApplymentList" :key="item.id">
            {{ item.applymentNo }} {{ applymentStatusFormat(item.applymentStatus, true) }}
          </span>
        </div>
      </div>
    </div>

    <!-- 旧申请单号 -->
    <div class="desp-items-group" v-if="isAuth('company:coordinate') && detail.excApplymentNo">
      <div class="desp-items-group-title">
        Linked Transaction No.
        <span v-if="detail.isRenew">(Be Renewed)</span>
        <span v-if="detail.isLaterService">(Have Supplements)</span>
      </div>
      <div class="desp-item">
        <div class="desp-item-self">
          <span>{{ detail.excApplymentNo }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Package from "@/components/ServiceGather/Package";
import DiyPackage from "@/components/ServiceGather/DiyPackage";
import QuotationList from "@/components/ServiceGather/QuotationList";
import formatterMixin from "@/mixins/formatterMixin";
import { mapActions, mapState } from "vuex";
export default {
  mixins: [formatterMixin],
  components: {
    Package,
    DiyPackage,
    QuotationList,
  },
  props: {
    detail: {
      type: Object,
      default: function () {
        return {
          id: null,
          applymentNo: null,
          applymentStatus: "",
          applicantName: "empty",
          applicantPhone: "empty",
          applicantEmail: "empty",
          country: "none",
          goodsList: [],
          excApplymentNo: null,
          linkedApplymentNo: null,
          laterServiceApplymentList: [],
          applicantPosition: null,
        };
      },
    },
  },
  data() {
    return {
      dataListLoading: false,
      applicantRole: null,
    };
  },
  watch: {
    "detail.applicantPosition"(newVal, oldVal) {
      this.applicantRole = newVal;
    },
  },
  computed: {
    ...mapState("constant", ["applicantPositionOptions"]),
  },
  methods: {
    ...mapActions("applyment", ["doSaveApplicantRole"]),
    // 发票跳转
    invoiceLink(invoiceNumber) {
      const newPage = `${process.env.VUE_APP_URL_INVOICE}/invoice?invoiceNo=${invoiceNumber}`;
      window.open(newPage, "_blank");
    },
    // 前台详情页链接
    userDetailLink(type, language) {
      this.$http.post(`/admin/accessManage/acquireAccessToken?businessNo=${this.detail.applymentNo}`, {}).then(res => {
        const resData = res.data || {};
        // 获取临时token
        const voucher = resData.token ? encodeURIComponent(resData.token) : null;
        let newpage = null;
        if (type == "details") {
          newpage = `${process.env.VUE_APP_URL_INVOICE}/enroll/details?id=${this.detail.id}&voucher=${voucher}`;
        } else {
          newpage = `${process.env.VUE_APP_URL_INVOICE}/feeLetter?id=${this.detail.id}&voucher=${voucher}&lang=${language}`;
        }
        window.open(newpage, "_blank");
      });
    },
    // 申请人角色
    applicantPositionChange(val) {
      this.$confirm("Confirm change of applicant role?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      })
        .then(() => {
          this.doSaveApplicantRole(val)
            .then(() => {
              this.$message({
                message: "success",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.applicantRole = val;
                },
              });
            })
            .catch(msg => {
              this.$message.error(msg);
            });
        })
        .catch(action => {
          this.applicantRole = this.detail.applicantPosition;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/variables.scss";

.to-link {
  cursor: pointer;
  color: #{$--color-primary};
  font-size: 14px;
  font-weight: bold;
  vertical-align: middle;
}
</style>
